import React from "react";
import { Modal } from "../../../components/modal/Modal";

const DetailsVKUModal = ({
  showDetailsVKUModal,
  onToggleDetailsVKUModal,
}: {
  showDetailsVKUModal: boolean;
  onToggleDetailsVKUModal: () => void;
}) => {
  return (
    <Modal
      modalNumber={5}
      isOpen={showDetailsVKUModal}
      onToggleModal={onToggleDetailsVKUModal}
      headerText="Verkehrskunde-Kurse"
    >
      <div className="flex flex-col gap-8 pt-6 h-full">
        <div className="flex flex-col gap-4">
          <p className="font-semibold font-title text-dark-blue text-xl">
            Allgemein
          </p>
          <div className="grid grid-cols-3 max-lg:grid-cols-2 font-content text-md text-light-gray space-y-2">
            <div>
              <p className="font-semibold">Kursdauer</p>
              <p className="">8 Lektionen (2 x 4 Lektionen)</p>
            </div>
            <div>
              <p className="font-semibold">Teilnehmerzahl</p>
              <p className="">4 bis max. 12 Teilnehmer</p>
            </div>
            <div>
              <p className="font-semibold ">Mindestalter</p>
              <p className="">14 Jahre und Lernfahrausweis</p>
            </div>
          </div>
          <div className="grid grid-cols-2 max-lg:grid-cols-1 space-y-2">
            <div className="font-content text-md text-light-gray">
              <p className="font-semibold">Kosten</p>
              <li className="font-content">
                VKU am Vor- oder Nachmittag: <br />
                für nur <strong>Fr. 130.-</strong>
              </li>
              <li className="font-content">
                VKU Abendkurs intensiv: <br />
                für nur <strong>Fr. 150.-</strong>
              </li>
              <li className="font-content">
                VKU Weekendkurs intensiv: <br />
                für nur <strong>Fr. 180.-</strong>
              </li>
            </div>
            <div className="font-content text-md text-light-gray">
              <p className="font-semibold">Kursleitung</p>
              <p className="">
                Lumi Begzzati, dipl. Fahrlehrer mit SVEB-Zertifikat
              </p>
            </div>
          </div>
          <div className="font-content text-md text-light-gray">
            <p className="">
              In den oben erwähnten Preisen ist <strong>alles inclusive</strong>{" "}
              (Kursunterlagen und Getränke) und für alle 8 Lektionen.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <p className="font-semibold font-title text-dark-blue text-xl">
            Kursort
          </p>
          <p className="font-content text-md text-light-gray">
            Römerstrasse 76, 8404 Winterthur, 6te Station vom Hauptbahnhof
            Winterthur, erreichbar mit Bus Nr. 1 Richtung Oberwinterthur, bei
            Busstation Stadtrain aussteigen.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DetailsVKUModal;
